import React from 'react'
import {useSuspense, useController} from '@data-client/react'
import {apiReply} from '../lib'
import {ActionHeader} from '../components'
import {EmailTable, SelectEmailReport} from '../components/Email'
import {EmailResource} from '../lib/model'
import {PageProps} from '../components/PageRouter'
import {Container} from '@mui/material'

// TODO: mark emails as read

export default function EmailsPage({session}: PageProps) {
  const [view, setView] = React.useState('All')
  const api = useController()
  const items = useSuspense(EmailResource.getList, {view, scope: session.euid()})

  const onUpdateItem = async ({read}: {read: number}) => {
    if (read) {
      const reply = {api, apiReply, error: null} // await apiReply(() => api.fetch(EmailResource.read, { id: read }, {}))
      // ui.update((state) => {
      //   state.unread--
      // })
      return !reply.error
    }
    return true
  }

  return (
    <Container maxWidth="md">
      <ActionHeader title="Email">
        <div style={{minWidth: '7rem'}}>
          <SelectEmailReport onChange={setView} />
        </div>
      </ActionHeader>
      <EmailTable emails={items} onUpdate={onUpdateItem} />
    </Container>
  )
}
